import devConfig from './config.dev';
import prodConfig from './config.prod';

function getMode() {
  return localStorage.mode === 'dev' ? 'dev' : 'prod';
}

function getNobackend() {
  return localStorage.nobackend === 'true';
}

const mode = getMode();
const config =  {
  ...(mode === 'dev' ? devConfig : prodConfig),
  nobackend: getNobackend()
};

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js